var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"display":"block"}},[_vm._v("\n    "+_vm._s((_vm.description + " " + _vm.amount + " " + _vm.currency))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }